
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Login from '../pages/login/page';
import Impressum from '../pages/impressum/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/impressum',
    element: <Impressum />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
